export default "__VITE_ASSET__CPkMG8jK__"